import { error } from 'services/graphql/fragments/Fragments';
import { incentiveStatusFields } from 'services/graphql/fragments/IncentiveFragments';
import { gql } from 'urql';

const OptInToIncentive = gql`
  mutation OptInToIncentive($input: OptInToIncentiveInput!) {
    optInToIncentive(input: $input) {
      __typename
      ... on OptInToIncentiveSuccess {
        status {
          ...incentiveStatusFields
        }
      }
      ... on OptInToIncentiveError {
        ...error
      }
    }
  }
  ${incentiveStatusFields}
  ${error}
`;

export default OptInToIncentive;
